import axios from 'axios';
import React, {useEffect, useState} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import './AddShow.css'
import loadgif from '../../Resources/loading2.gif'
import BASE_URL from '../../constant';


function AddShow() {

    const params = useParams();
    const navigate = useNavigate();
    const {theatreId} = params;
    const [time, setTime] = useState("");
    const [movieData, setMovieData] = useState([]);
    const [movieId, setMovieId] = useState("");
    const storedAdmin = JSON.parse(localStorage.getItem("adminData"));
    const [logStatus, setLogStatus] = useState(true);
    const [loading, setLoading] = useState(false);


    useEffect(()=>{
        if(!storedAdmin){
            setLogStatus(false)
            return
        }
        axios.get(`${BASE_URL}/bookmyshow/api/v1/movie`)
        .then(res => {
            setMovieData(res.data);
        })
        .catch(err => console.log(err.message));
    },[storedAdmin])


    const handleSubmit = (e)=>{
        setLoading(true);
        e.preventDefault();
        axios.post(`${BASE_URL}/bookmyshow/api/v1/shows/${theatreId}`, {
            movieId,
            time
        })
        .then(res => {
            console.log(res.data);
            setLoading(false);
            navigate('/admin');
        })
        .catch(err => {
            console.log(err.message);
            setLoading(false);
        });
    }

  return (
    <div className='addmoviesCont' >
        {(!logStatus) ? "Unauthorised access" : 

        <form className="form addShow-form"  method="post" encType="multipart/form-data">
        <div className="input-field">
        <div className='heading'>Movie Name</div>
        <select value={movieId} onChange={(e) => setMovieId(e.target.value)} name="movieId" id="movies">
        <option value="">Select Movie</option>
                {
                    movieData && movieData.map((movie)=>{
                        return <option key={movie._id} value={movie._id}>{movie.name}</option>
                    })
                }
            </select>
        </div>
        <div className="heading">
            <i className='fa-solid fa-clock'></i>&nbsp;
            Set shows timing
        </div>
        <div className="input-field">    
            <span>Use Format - (10:00 AM, 12:30 PM, 4:00 PM etc...)</span>
            <input name="time" type="text" 
            onChange={(e)=>{setTime(e.target.value)}} 
            value={time} className="input"  />
        </div>


        <div className="submitBtnContainer">
        {
            (loading) ? <button className="submitBtn" >
                <img src={loadgif} alt="" /> Processing...
            </button> : 
            <button className="submitBtn" onClick={handleSubmit} >
                Add shows
            </button>
        }
        </div>
        </form>
}    </div>
  )
}

export default AddShow
